import isNil from "lodash/fp/isNil";
import { getUriHash } from "../../core/utils";
class Controller {
  constructor() {
    "ngInject";
    this.params = {};
    this.redirectPage = "";
    this.id = "";
  }

  $onInit() {
    this.params = getUriHash(this.params);
    const redirectParams = this.params.state.split("-");
    const originUrl = location.origin;
    if (isNil(redirectParams)) {
      // Sad
      history.back();
    } else {
      this.redirectPage = redirectParams[0];
      this.id = redirectParams[1];
      window.location.replace(
        `${originUrl}/${this.redirectPage}/${this.id}#access_token=${this.params.access_token}`
      );
    }
  }
}
export default Controller;



// WEBPACK FOOTER //
// ./src/pages/redirector/redirector.controller.js